import { State, Action } from "./types";

export const reducer = (state: State, action: Action): State => {
  const actionType = action.type;

  switch (action.type) {
    case "SET_VIEW_MODE":
      return {
        ...state,
        viewMode: action.viewMode,
      };
    default:
      throw new Error(`Unhandled action type: ${actionType}`);
  }
};
